import { API } from '@/shared/api/modules';
import type { GetFacilitiesPerformanceRequestDto } from '@/shared/api/modules/facilities';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getFacilitiesPerformanceQueryOptions = (
  params: GetFacilitiesPerformanceRequestDto
) =>
  queryOptions({
    queryKey: ['facilities-performance', params],
    queryFn: async ({ signal }) => {
      return await API.facilities.getFacilitiesPerformance(params, { signal });
    },
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
    enabled: !!params.from && !!params.to,
  });
